var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.delayedPercents > 0)?_c('div',{staticClass:"state-alert"},[_c('div',[_c('span',[_vm._v("约")]),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_setup.percents))])]),_c('div',[_vm._v("施工任务滞后")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }